import { type Team } from "@entities";

export function findParentsLink(comm: Team) {
  const links: { content: string; path: string }[] = [];
  const traverseParents = (team: Team) => {
    if (team.parentTeam) {
      const parentTeam = team.parentTeam.team;
      if (parentTeam) {
        traverseParents(parentTeam);
        links.push({
          content: parentTeam.name,
          path: `/volunteers/teams/${parentTeam.id}`,
        });
      }
    }
  };
  traverseParents(comm);
  return links;
}
